import { useMutation, useQueryClient } from "react-query"
import { useMarina } from "src/contexts/MarinaContext"

import { updateProductStatus } from "src/api/ManageItems"

import { useToast } from "src/hooks/use_toast"
import { useTracker } from "src/hooks/use_tracker"

// Reactivates a soft-deleted catalog product from the job-template / work-order
// line-item surfaces. Distinct from ManageItems' own `useReactivateProduct`
// (catalog form): this one invalidates the jobTemplates queries, tracks the
// `service:product_reactivated` event, and exposes per-row loading state.
export const useReactivateLineItemProduct = ({ onReactivated } = {}) => {
  const { marinaSlug } = useMarina()
  const showToast = useToast()
  const queryClient = useQueryClient()
  const tracker = useTracker()

  const { mutate, variables, isLoading } = useMutation(
    (productId) =>
      updateProductStatus({ marinaSlug, id: productId, status: "active" }),
    {
      onSuccess: (_data, productId) => {
        queryClient.invalidateQueries(["jobTemplates", marinaSlug])
        onReactivated?.(productId)
        tracker.trackEvent("service:product_reactivated", { productId })
        showToast("Item reactivated.", { type: "success" })
      },
      onError: (error) => {
        showToast(error.message || "Failed to reactivate item.", {
          type: "error",
        })
      },
    }
  )

  return {
    reactivate: mutate,
    reactivatingProductId: isLoading ? variables : null,
  }
}
